import { useState, useEffect } from 'react';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

// An on-screen keyboard shrinks the viewport rather than sliding over it but
// nothing drawn underneath that overlay should reflow just because a field
// was focused though, so the shrink is ignored here and the diagram keeps the
// size it already had. A keyboard is raised by focusing a field and never
// changes the width, which tells it apart from a rotation or the address bar
// retracting.
function isKeyboardResize(previous) {
  const element = document.activeElement;
  const editable = element && (element.tagName === 'INPUT' ||
                               element.tagName === 'TEXTAREA' ||
                               element.isContentEditable);
  return editable && window.innerWidth === previous.width;
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    // A keyboard sliding in or out arrives as a run of resizes, one per frame of
    // its animation, and laying the diagram out at each intermediate size makes
    // it flicker on the way past. Use a timer which waits for the resize to settle
    // before updating the window dimensions.
    let settle_timer = null;

    function handleResize() {
      clearTimeout(settle_timer);
      settle_timer = setTimeout(() => {
        // setWindowDimensions after the timeout expires but only if
        // it is not a keyboard resize. (Otherwise keep previous.)
        setWindowDimensions((previous) =>
          isKeyboardResize(previous) ? previous : getWindowDimensions());
      }, 150);
    }

    window.addEventListener('resize', handleResize);
    return () => {
      clearTimeout(settle_timer);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowDimensions;
}
